module.exports = __webpack_public_path__ + "static/media/  (115).422d385b.jpg";